export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_UPDATE = 'AUTH_UPDATE';
export const PROFILE_GET = 'PROFILE_GET';
export const PHOTO_UPDATE = 'PHOTO_UPDATE';